import { Injectable } from '@angular/core';
import { Firestore, collection, doc, query, where } from '@angular/fire/firestore';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as fromPerimeterActions from '../actions/perimeters.actions';

import { Observable, of } from 'rxjs';
import { map, catchError, switchMap, take } from 'rxjs/operators';
import { FirebaseService } from '../../services/firebase/firebase.service';
import { PerimeterFirebaseResponse } from '../../models/perimeters.model';

@Injectable()
export class PerimetersEffects {

    constructor(
        private readonly action$: Actions,
        private readonly firestore: Firestore,
        private readonly firebaseService: FirebaseService,
    ) { }

    // Load Perimeter
    loadPerimeter$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromPerimeterActions.LoadPerimeterAction),
        switchMap(({ data }) => {
            const userRef = doc(this.firestore, `users/${data.id}`);
    
            const ref = query(
                collection(this.firestore, 'perimeters'),
                where('userRef', '==', userRef)
            );

            return this.firebaseService.getDataOfCollectionByField(ref).pipe(take(1), map((resp) => resp.map((doc) => ({
                ...doc as PerimeterFirebaseResponse
            }))));
        }),
        map((data) => {
            let perimeters: PerimeterFirebaseResponse = { registers: [] };
            if (data?.length > 0) {
                perimeters = data[0];
                perimeters.registers = perimeters.registers.map((register) => ({ ...register, date: new Date((register.date as unknown as { seconds: number }).seconds * 1000) }))
                delete perimeters.userRef;
            }
            return ({ type: fromPerimeterActions.LOAD_PERIMETER_SUCCESS, data: perimeters });
        }),
        catchError(error => of({ type: fromPerimeterActions.LOAD_PERIMETER_FAIL, error: error }))
    ));

    // Add Perimeter
    addPerimeter$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromPerimeterActions.AddPerimeterAction),
        switchMap(async ({ data, user }) => {
            const userRef = doc(this.firestore, `users/${user.id}`);
            const perimeter: PerimeterFirebaseResponse = {
                ...data,
                userRef
            };

            const resp = await this.firebaseService.addDoc('perimeters', perimeter);

            return { ...data, id: resp.id };
        }),
        map((data) => ({ type: fromPerimeterActions.ADD_PERIMETER_SUCCESS, data })),
        catchError(error => of({ type: fromPerimeterActions.ADD_PERIMETER_FAIL, error: error }))
    ));

    // Update Perimeter
    updatePerimeter$: Observable<Action> = createEffect(() => this.action$.pipe(
        ofType(fromPerimeterActions.UpdatePerimeterAction),
        switchMap(async ({ data, user }) => {
            const userRef = doc(this.firestore, `users/${user.id}`);
            const perimeter: PerimeterFirebaseResponse = {
                ...data,
                userRef
            };
            delete perimeter.id;

            await this.firebaseService.updateDoc('perimeters', data.id!, perimeter);
            return data;
        }),
        map((data) => ({ type: fromPerimeterActions.UPDATE_PERIMETER_SUCCESS, data })),
        catchError(error => of({ type: fromPerimeterActions.UPDATE_PERIMETER_FAIL, error: error }))
    ));
}